/* eslint react/prop-types: 0 */
import React from 'react';
// import moment from 'moment';
import PropTypes from 'prop-types';

const Event = (selected_date_id, loading) => ({ event }) => {
  if (loading) {
    return <div />;
  }
  return (
    <div
      className={`text-center ${
        selected_date_id === event.id ? `selected` : ``
      }`}
    >
      <span style={{ fontSize: 10 }}>
        {event.title}
      </span>
    </div>
  );
};

export default Event;

Event.propTypes = {
  event: PropTypes.instanceOf(Object).isRequired,
};
